<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Portal-Complaint-Create",
  short_name: "New Complaint",
  path: "create",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
